export const REQUEST_POPUP_LIST = "REQUEST_POPUP_LIST"
export const REQUEST_POPUP = "REQUEST_POPUP"